import React from "react";
import AnimationWrapper from "../../containers/AnimationWrapper";

interface Props {
  className?: string;
  id?: string;
}

export const Equals: React.FC<Props> = ({ className, id = "a" }) => {
  const fillUrl = `url(#${id})`;

  return (
    <div className={className}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 475 137">
        <defs>
          <linearGradient
            id={id}
            x2=".877"
            y1="1"
            y2="1"
            gradientUnits="objectBoundingBox"
          >
            <stop offset="0" stopColor="#9ee6e8" />
            <stop offset="1" stopColor="#9ee6e8" stopOpacity="0" />
          </linearGradient>
        </defs>
        <g
          fill={fillUrl}
          data-name="Group 34"
          transform="translate(.626 -2150.719)"
        >
          <path d="M-.626 2150.719h475v46h-475z" data-name="Rectangle 50" />
          <path d="M-.626 2241.719h475v46h-475z" data-name="Rectangle 52" />
        </g>
      </svg>
    </div>
  );
};

export const WideEquals: React.FC<Props> = ({ className, id }) => {
  const fillUrl = `url(#${id})`;
  return (
    <AnimationWrapper className={className} behavior={"brighten"}>
      <svg xmlns="http://www.w3.org/2000/svg" width={510} height={107}>
        <defs>
          <linearGradient
            id={id}
            x2={0.877}
            y1={1}
            y2={1}
            gradientUnits="objectBoundingBox"
          >
            <stop offset={0} stopColor="#9ee6e8" />
            <stop offset={1} stopColor="#9ee6e8" stopOpacity={0} />
          </linearGradient>
        </defs>
        <g
          fill={fillUrl}
          data-name="Group 115"
          transform="translate(.198 -2150.416)"
        >
          <path d="M-.198 2150.416h510v36h-510z" data-name="Rectangle 50" />
          <path d="M-.198 2221.416h510v36h-510z" data-name="Rectangle 52" />
        </g>
      </svg>
    </AnimationWrapper>
  );
};

export const HeroEquals: React.FC<Props> = ({ className, id }) => {
  const fillUrl = `url(#${id})`;

  return (
    <AnimationWrapper className={className} behavior={"lengthen"}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 510 107">
        <defs>
          <linearGradient
            id={id}
            x2={0.877}
            y1={1}
            y2={1}
            gradientUnits="objectBoundingBox"
          >
            <stop offset={0} stopColor="#9ee6e8" />
            <stop offset={1} stopColor="#9ee6e8" stopOpacity={0} />
          </linearGradient>
        </defs>
        <g
          fill={fillUrl}
          data-name="Group 115"
          transform="translate(.198 -2150.416)"
        >
          <path d="M-.198 2150.416h510v36h-510z" data-name="Rectangle 50" />
          <path d="M-.198 2221.416h510v36h-510z" data-name="Rectangle 52" />
        </g>
      </svg>
    </AnimationWrapper>
  );
};
